import React, { useState } from 'react'
import "./AddPlanModal.css"
import PartApiCall from './PartApiCall'
import { useSelector } from 'react-redux'
import { validateInput } from '../inputValidator/useValidator'


export default function AddPlanForm({CloseAddPlanModel,filteredData}) {

  
    const [selectedPart, setSelectedPart] = useState()
    const [errors , setErrors] = useState({});

    const[addPlanFormData, setAddPlanFormData] = useState({
        selectedQuantity : "",
        selectedFromDate : "",
        selectedToDate : "",
    })
   
    const handleChange = (e) => {
        const emptyValidation = true;
        const lessThanZeroValidation = true;
        const lessThanTodayValidation = true
        const {name, value, type} = e.target
        const error = validateInput(name, value, type, emptyValidation, lessThanZeroValidation,lessThanTodayValidation)
        setErrors(error)
        setAddPlanFormData({
         ...addPlanFormData,
          [name] : value
        }) 
    }

    const errorBoxSize = Object.keys(errors).length


    let plantId = useSelector((state) => state.saveSelectedPlant);
    if(plantId.addPlanModal){
        plantId = plantId.addPlanModal.selectedOption.value;
    }else {
        plantId = "";
    }
    
    let lineId = useSelector((state) => state.saveSelectedLine);
  if (lineId.addPlanModal) {
    lineId = lineId.addPlanModal.selectedOption.value;
  } else {
    lineId = "";
  }

  let machineId = useSelector((state) => state.saveSelectedMachine);
  if (machineId.addPlanModal) {
    machineId = machineId.addPlanModal.selectedOption.value;
  } else {
    machineId = "";
  }


  
  const handleSubmit =()=>{
    const {selectedQuantity, selectedFromDate ,selectedToDate} = addPlanFormData
    console.log(selectedQuantity, selectedFromDate ,selectedToDate);
    console.log(plantId, lineId, machineId);
    console.log(selectedPart);
    //////READY TO POST DATA
   }
  
  return (
    <>
    <div className="popUpFormFields">
                    <h6 className="text-center">Production Plan for Machine</h6><hr/>
                    <div className="row">
                       <PartApiCall SelectedPart={setSelectedPart} filteredData={filteredData}/>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Quantity</label>
                                <input name='selectedQuantity' onChange={handleChange}  type="Number" placeholder="Quantity" className="form-control"/>
                                {errors.lessThanZeroValidation && <p style={{color : "red"}}>* {errors.lessThanZeroValidation}</p>}
                                {errors.emptyValidation && <p style={{color : "red"}}>* {errors.emptyValidation}</p>}  
                            </div>
                        </div>
                        <label>&nbsp;</label>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>From Date</label>
                                <input name='selectedFromDate' onChange={handleChange} type="datetime-local" placeholder="From Date" className="form-control" />
                                {errors.lessThanTodayValidation && <p style={{color : "red"}}>* {errors.lessThanTodayValidation}</p>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>To Date</label>
                                <input name='selectedToDate' onChange={handleChange}  type="datetime-local" placeholder="To Date" className="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                <div className="row form-group">
                    <div className="col-12">
                        <button onClick={()=> CloseAddPlanModel(false)} className="btn btn-default">Cancel</button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button onClick={handleSubmit} className="btn btn-primary" disabled={errorBoxSize}>Save</button>
                    </div>
                </div>
            </div>
    </>
  )
}
